import { useLayoutEffect, useState } from "react";
import useResizeObserver from '@react-hook/resize-observer';
import useDebounce from "../use-debounce/UseDebounce";

// From https://www.npmjs.com/package/@react-hook/resize-observer
// Example https://codesandbox.io/s/react-hookresize-observer-example-ft88x?file=/src/App.js

export default function useSize(target: HTMLElement | undefined) {

    const [size, setSize] = useState<DOMRect>();
    // The debounced size.
    const sizeDb = useDebounce(size, 50);

    useLayoutEffect(() => target && setSize(target.getBoundingClientRect()),
        [target]);

    useResizeObserver(target ?? null, (entry) => setSize(entry.contentRect));
    return sizeDb;
}